import { accessRole } from "../../../../helpers/access_role"
import classnames from "classnames"

import React, { Component, Fragment, useState, useRef, useEffect } from "react"
import apiResponse from "../../../../services/apiResponse"
import { ConfirmAlert } from '../../../../helpers/ui/alert'

import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Nav,
    NavItem,
    NavLink,
    TabContent,
    TabPane,
    Input,
    UncontrolledAlert
} from "reactstrap"


import moment from "moment"
import IndexBloc from "./Blocs/IndexBloc"

import CustomSelect from "../../GlobalComponents/CustomSelect"

import TableActiveComponent from './Components/TableActiveComponent'
import TableDoneComponent from './Components/TableDoneComponent'

const createYearOption = (startYear = 2000) => {
  var currentYear = new Date().getFullYear(), years = [];
    startYear = startYear || 1980;  
    while ( startYear <= currentYear ) {
        var newObj = {};
        var year = startYear++;
        newObj["label"] = year;
        newObj["value"] = year;
        years.push(newObj);
    }   
    return years;
}
  
const createMonthOptions = () => {
    var months = [
        "Januari",
        "Februari",
        "Maret",
        "April",
        "Mei",
        "Juni",
        "Juli",
        "Agustus",
        "September",
        "Oktober",
        "November",
        "Desember",
    ];

    return months.map(function(month, i) {
        var newObj = {};
        newObj["label"] = month;
        newObj["value"] = ++i;

        return newObj;
    });
}

const IndexView = (props) => {

    let indexBloc = new IndexBloc();

    const [activeTab, setactiveTab] = useState("1")
    

    const activeRef = useRef();
    const inactiveRef = useRef();

    const reloadActiveRef = () => activeRef.current.setTokenAPI()
    const reloadInactiveRef = () => inactiveRef.current.setTokenAPI()

    function toggle(tab) {
        if (activeTab !== tab) {
            setactiveTab(tab)
        }
    }

    return (
        <Fragment>
            <Container fluid>
                <Card>
                    <CardBody>
                        <CardTitle>Verifikasi Pembatalan Presensi</CardTitle>
                        <CardSubtitle className="mb-3">
                            Daftar Seluruh Pembatalan Presensi
                        </CardSubtitle>
                        <hr />

                        <Nav tabs>
                            <NavItem>
                                <NavLink
                                    style={{ cursor: "pointer" }}
                                    className={classnames({
                                        active: activeTab === "1",
                                    })}
                                    onClick={() => {
                                        toggle("1")
                                    }}
                                >
                                    <span className="d-block d-sm-none"><i className="fas fa-home"></i></span>
                                    <span className="d-none d-sm-block">Menunggu Verifikasi</span>
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink
                                    style={{ cursor: "pointer" }}
                                    className={classnames({
                                    active: activeTab === "2",
                                        })}
                                    onClick={() => {
                                        toggle("2")
                                    }}
                                >
                                    <span className="d-block d-sm-none"><i className="far fa-envelope"></i></span>
                                    <span className="d-none d-sm-block">Selesai</span>
                                </NavLink>
                            </NavItem>
                        </Nav>
                        <TabContent activeTab={activeTab} className="p-3 text-muted">
                            <TabPane tabId="1">
                                <TableActiveComponent ref={activeRef} handleInactiveSuccess={reloadInactiveRef}/>
                            </TabPane>
                            <TabPane tabId="2">
                                <TableDoneComponent ref={inactiveRef} />
                            </TabPane>
                        </TabContent> 

                    </CardBody>
                </Card>
            </Container>
        </Fragment>
    )

}

export default IndexView